import * as Yup from 'yup';

export const SignUpBasicInfoSchema = Yup.object().shape({
  businessName: Yup.string()
    .min(1)
    .required('please provide your business name'),
  email: Yup.string().email().required('email is required'),
  phoneNumber: Yup.string()
    .min(8)
    .required('please provide your phone number'),
});

export type SignUpBasicInfoDataType = Yup.InferType<typeof SignUpBasicInfoSchema>;

type InitialValues = {
  businessName: string;
  email: string;
  phoneNumber: string;
};

export const signUpBasicInfoInitialValues: InitialValues = {
  businessName: '',
  email: '',
  phoneNumber: '',
};


export interface BasicInfoSliderInterface {
  businessName: string;
  email: string;
  phoneNumber: string;
}
